/**
 *
 * Button.js
 *
 * A common button, if you pass it a prop "route" it'll render a link to a react-router route
 * otherwise it'll render a link with an onclick
 */

import React, { Children } from 'react';
import PropTypes from 'prop-types';

import A from './A';
import StyledButton from './StyledButton';
import Wrapper from './Wrapper';

function Button(props) {
  let button = null;
  if (props.handleRoute) {
    button = (
      <StyledButton {...props} onClick={props.handleRoute}>
        {Children.toArray(props.children)}
      </StyledButton>
    );
  } else if (props.href) {
    button = (
      <A {...props}>
        {Children.toArray(props.children)}
      </A>
    );
  } else {
    button = (
      <StyledButton type="button" {...props}>
        {Children.toArray(props.children)}
      </StyledButton>
    );
  }

  return (
    <Wrapper>
      {button}
    </Wrapper>
  );
}

Button.propTypes = {
  handleRoute: PropTypes.func,
  href: PropTypes.string,
  children: PropTypes.node,
};

export default Button;



// WEBPACK FOOTER //
// ./app/components/Button/index.js